<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>

// Plugins
import Vue from 'vue'
import VueYouTubeEmbed from 'vue-youtube-embed'

Vue.use(VueYouTubeEmbed)

export default {
	name: 'app',
	data: () => ({
		user: {
			AccountId: '',
			EventId: '',
			Salutation: '',
			Firstname: '',
			Lastname: '',
			Title: '',
			Company: '',
			Division: '',
			Address1: '',
			Address2: '',
			City: '',
			State: '',
			Zip: '',
			Country: '',
			TelCountryCode: '',
			Phone1: '',
			Phone2: '',
			Fax: '',
			Email: '',
			URL: '',
		}
	}),
	mounted ()
	{
		if( this.$route.query ) {

		}
	},
	watch: {
		'$route' (to, from)
		{
			if( to.query && to.query.AccountId ) {
				if( to.query.AccountId !== from.query.AccountId ) {
					
				}
			}
		}
	}
}
</script>

<style lang="scss">
	@import './styles/main';

	#app {
		display: flex;
		flex-direction: column;
		flex: 1;
		min-height: 100%;
		overflow: hidden;
		width: 100%;
	}

	.list {

		&__title {
			color: color_('text','dark');
			font-weight: bold;
			font-size: rem(35px);
		}
	}

	.page {

		 &__title {
			color: color_('text','dark');
			font-weight: bold;
			font-size: rem(35px);		 	
		 }
	}

	.transition {

		&--fade {
			&-enter-active {
				@include fadeInAnimation();
			}

			&-leave-active {
				@include fadeOutAnimation();
			}
		}

		&--slide {
			&-enter-active {
				animation: slideRightIn 250ms $easing-material;
			}

			&-leave-active {
				animation: slideLeftOut 250ms $easing-material;
			}
		}

	}
</style>



// WEBPACK FOOTER //
// src/App.vue